import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { requestSilent } from "@/Api"
import { useDispatch } from "react-redux"
import { logout } from "@/auth/authSlice"

export default function Logout() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    useEffect(() => {
        dispatch(logout())
        requestSilent.post("logout")
        navigate("/login")
    }, [])

    return null
}
